export const spacing = {
    space0: '0px',
    space1: '1px',
    space2: '2px',
    space4: '4px',
    space8: '8px',
    space12: '12px',
    space16: '16px',
    space20: '20px',
    space24: '24px',
    space28: '28px',
    space32: '32px',
    space36: '36px',
    space40: '40px',
    space48: '48px',
    space64: '64px',
    space80: '80px',
    space96: '96px',
    space128: '128px',
};
//# sourceMappingURL=spacing.js.map